import { Province } from '../../services/lookups.service';

// Re-export imported types
export type { Province };

export interface GeneralContractorFormData {
  id: string;
  name: string;
  address: string;
  city: string;
  province: string;
  postalCode: string;
  active: boolean;
  coordinates?: [number, number];
}

export interface FormErrors {
  name: string;
  address: string;
  city: string;
  province: string;
  postalCode: string;
  [key: string]: string;
}

export interface FilterParams {
  search?: string;
  page?: number;
  limit?: number;
  sortBy?: string;
  sortOrder?: 'asc' | 'desc';
}

export interface SortConfig {
  key: string;
  direction: 'asc' | 'desc' | null;
}

export interface ActiveFilters {
  status: string[];
  generalContractor: string[];
  search: string;
}

// Initial form data
export const initialFormData: GeneralContractorFormData = {
  id: '',
  name: '',
  address: '',
  city: '',
  province: '',
  postalCode: '',
  active: true,
};

// Validation regex
export const postalCodeRegex = /^[A-Za-z]\d[A-Za-z][ -]?\d[A-Za-z]\d$/;

// Status options for dropdown
export const statusOptions = [
  { value: true, label: 'Active' },
  { value: false, label: 'Inactive' }
];